import {
    EntityAdapter,
    EntityState as ngEntityState,
    createEntityAdapter, EntityState,
} from "@ngrx/entity";
import {FriendReaction, ReactionCount} from "./reactions.model";

export const reactionCountsAdapter = createEntityAdapter<ReactionCount>({
    selectId: r => r.id
});

export const friendReactionCountsAdapter = createEntityAdapter<FriendReaction>({
    selectId: m => m.id
});




export interface ReactionsState {
    reactionCounts: EntityState<ReactionCount>;
    friendReactionCounts: EntityState<FriendReaction>;
}

export const initialReactionsState: ReactionsState = {
    reactionCounts: reactionCountsAdapter.getInitialState(),
    friendReactionCounts: friendReactionCountsAdapter.getInitialState(),
};

